import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ResponsabilidadPlanPayload {
  id_plan: number;
  id_cargo: number;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface ResponsabilidadPlan {
  CargosData: any;
  id?: number;
  id_plan: number;
  id_cargo: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface ResponsabilidadPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ResponsabilidadPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/responsabilidad_plan`;

  constructor(private http: HttpClient) {}

  // Listar todas las responsabilidades
  getAll(): Observable<ResponsabilidadPlan[]> {
    return this.http.get<ResponsabilidadPlan[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<ResponsabilidadPlan> {
    return this.http.get<ResponsabilidadPlan>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  getByIdPlan(id_plan: number): Observable<ResponsabilidadPlan[]> {
    return this.http.get<ResponsabilidadPlan[]>(
      `${this.apiUrl}/plan/${id_plan}`,
      { withCredentials: true },
    );
  }

  // Crear nueva responsabilidad
  create(
    payload: ResponsabilidadPlanPayload,
  ): Observable<ResponsabilidadPlanResponse> {
    return this.http.post<ResponsabilidadPlanResponse>(this.apiUrl, payload, {
      withCredentials: true,
    });
  }

  // Actualizar responsabilidad
  update(
    id: number,
    payload: Partial<ResponsabilidadPlanPayload>,
  ): Observable<ResponsabilidadPlanResponse> {
    return this.http.put<ResponsabilidadPlanResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      { withCredentials: true },
    );
  }

  // Eliminar responsabilidad (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  // Inactivar responsabilidad
  inactivar(id: number): Observable<ResponsabilidadPlanResponse> {
    return this.http.put<ResponsabilidadPlanResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      { withCredentials: true },
    );
  }

  // Activar responsabilidad
  activar(id: number): Observable<ResponsabilidadPlanResponse> {
    return this.http.put<ResponsabilidadPlanResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      { withCredentials: true },
    );
  }
}